import { GeneralOverlay } from "../general/general-overlay";
class FacetMobileToggle extends HTMLElement {
    constructor() {
        super();
        this.bindEvents();
    }

    bindEvents() {
       this.addEventListener("click", this.openFacetDrawer.bind(this))
    }

    openFacetDrawer() {
        const facetDrawer = this.nextElementSibling;
        facetDrawer?.classList.add("open");
      
        const generalOverlay = new GeneralOverlay();
        generalOverlay.applyOverlay(document.querySelector("facet-mobile-drawer")); 
    }
}

class FacetMobileDrawer extends HTMLElement {
    constructor() {
        super();
        this.bindEvents();
    }

    bindEvents() {
        const closeIcon = this.querySelector(".collection__facets-draw-heading .close");
        closeIcon?.addEventListener("click", this.closeFacetDrawer.bind(this));

        const facetHeadings = this.querySelectorAll(".collection__facet-heading");
        facetHeadings.forEach((element) => {
            element?.addEventListener("click", this.toggleFacetOptions.bind(this));
        })
    }

    closeFacetDrawer() {
        this.classList.remove("open");
        
        const generalOverlay = new GeneralOverlay();
        generalOverlay.removeOverlay(this);
    }

    toggleFacetOptions(event: Event) {
        const target = event.currentTarget as HTMLElement;
        const facetOptions = target.nextElementSibling;
        facetOptions?.classList.toggle("open");
    }
}

customElements.define("facet-mobile-drawer", FacetMobileDrawer);
customElements.define("facet-mobile-toggle", FacetMobileToggle);


